const menus = [
    {
        id: 1,
        name: 'Home',
        links: '#',
        namesub: [
            {
                id: 1,
                sub: 'PepePal',
                links: '/'
            },
        ]
    },
    {
        id: 2,
        name: 'About',
        links: '/about'
    },{
        id: 3,
        name: 'Listings',
        links: '/Partners'
    },
    {
        id: 4,
        name: 'Links',
        links: '#',
        namesub: [
            {
                id: 3,
                sub: 'Our Mission',
                links: '/our-mission'
            },
            {
                id: 4,
                sub: 'FAQ',
                links: '/faq'
            },
        ],
    },
    {
        id: 5,
        name: 'Chart',
        links: 'https://www.dextools.io/app/en/ether/pair-explorer/0x1806e9c4d91a39bb0deb33b5761868216aa7a041'
    },
    
]

export default menus;